/**
 * What a Cinch AI message needs before it can be sent (Justin, 2026-10-30): text, ready files, or
 * both. Files still uploading or failed don't count; they stay in the composer for the next message.
 */

export const readyAttachments = attachments => (attachments || []).filter(a => a.status === 'ready');
export const canSend = (text, attachments) => !!(text || '').trim() || readyAttachments(attachments).length > 0;